import SearchIcon from "@mui/icons-material/Search";
import { TabContext } from "@mui/lab";
import { Collapse, Tab, Typography } from "@mui/material";
import { Gauge, gaugeClasses } from "@mui/x-charts";
import React from "react";
import StarShrinkIco from "../../../assets/icons/StarShrinkIco";
import CommonButton from "../../../component/Button";
import CommonTextField from "../../../component/Input";
import { getColor } from "../../../utils/constants";
import FullSizeChatBot from "../../chat-bot/FullSizeChatBot";
import { CustomDiv } from "../../chat-bot/style";
import {
  CommonGrid2,
  DotColor,
  QuickViewTab,
  StatusChange,
} from "../../common-components/StyledComponents";
import { CustomizeSpan } from "../../jobs/style";
import { TableData, TableHead } from "../style";

export default function QuickView({
  quickViewValue,
  handleQuickViewTabChange,
  handleActivityChange,
  chatBotData,
  setChatBotData,
  gridRef,
}) {
  const tabData = [
    { name: "SOW Requirement" },
    { name: "Summary" },
    { name: "Job" },
  ];

  const data = [
    {
      title: "Total Candidate",
      value: 8,
    },
    {
      title: "Cover Sheet",
      value: 2 / 3,
    },
    {
      title: "Submission",
      value: "-",
    },
    {
      title: "Mathew Dudda",
      value: "In Progress",
      condition: true,
      score: 80,
      max_score: 100,
      color: "green",
    },
    {
      title: "Aaron Dudda",
      value: "Inprogress",
      condition: true,
      score: 10,
      max_score: 100,
      color: "red",
    },
    {
      title: "Harold Hababou",
      value: "Rejected",
      condition: true,
      score: 50,
      max_score: 100,
      color: "orange",
    },
  ];

  const tableData = [
    {
      title: "Cover Sheet sent to three shortlisted candidates",
      time: "11:00am",
      date: "14/May/2025",
    },
    {
      title: "8 Resumes scored and shortlisted",
      time: "9:00am",
      date: "13/May/2025",
    },
    {
      title: "Job Created on 12/May/2025",
      time: "10:00am",
      date: "12/May/2025",
    },
  ];

  const tableHead = [
    { title: "Activity", width: "40%" },
    { title: "Time", width: "10%" },
    { title: "Day", width: "10%" },
  ];
  return (
    <CustomDiv
      height={"calc(100vh - 137px)"}
      overflowY="auto"
      display="flex"
      width="calc(100% + 2rem)"
      position="relative"
      left="-1rem"
      gap="0.8rem"
    >
      <TabContext value={quickViewValue}>
        <CommonGrid2
          width={"calc(100% - 300px)"}
          border={"1px solid rgba(0, 0, 0, 0.12)"}
          borderRadius={"10px"}
          position={"relative"}
          background="#F6F8FB"
          height="100%"
        >
          <CommonGrid2
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"space-between"}
            overflow={"auto"}
            padding={"1rem"}
            height={"-webkit-fill-available"}
            scrollBar="6px"
            scrollStyle
          >
            <CustomDiv>
              <Typography
                variant="body5"
                color="#8396A8"
                fontWeight={700}
                sx={{
                  background:
                    "linear-gradient(149deg, #5A35B2 3.87%, #FA4F96 40%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Here is the status of the job
                <CustomizeSpan margin="0px 0px 0px 8px">
                  <StarShrinkIco />
                </CustomizeSpan>
              </Typography>
              <CommonGrid2
                display={"flex"}
                flexWrap={"wrap"}
                gap={"1rem"}
                margin={"1rem 0px 0px"}
              >
                <Typography variant="h5">
                  Senior Java Developer - Apple
                </Typography>
                <StatusChange>
                  <DotColor color={getColor(90)} />
                  {"Active"}
                </StatusChange>
              </CommonGrid2>

              {/* <CustomDiv> */}
              <Collapse
                in={chatBotData.details === "Hide Details"}
                timeout={400}
                unmountOnExit
              >
                <CommonGrid2 container spacing={1} margin={"1rem 0px"}>
                  {data.map((item, index) =>
                    !item.condition ? (
                      <CommonGrid2
                        display={"flex"}
                        key={item.index}
                        size={4}
                        flexDirection={"column"}
                        padding={"10px"}
                        border={"1px solid #EAECF0"}
                        borderRadius={"10px"}
                        background="#fff"
                        gap={"5px"}
                      >
                        <Typography
                          variant="subtitle1"
                          fontWeight={500}
                          color="#738496"
                        >
                          {item.title}
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          color="#38414A"
                          fontWeight={600}
                        >
                          {item.value}
                        </Typography>
                      </CommonGrid2>
                    ) : (
                      <CommonGrid2
                        display={"flex"}
                        key={item.index}
                        size={4}
                        padding={"10px"}
                        border={"1px solid #EAECF0"}
                        borderRadius={"10px"}
                        background="#fff"
                        gap={"5px"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                      >
                        <CommonGrid2 flexDirection={"column"}>
                          <Typography
                            variant="subtitle1"
                            fontWeight={600}
                            color="#738496"
                          >
                            {item.title}
                          </Typography>
                          <Typography
                            variant="subtitle1"
                            color="#38414A"
                            fontWeight={600}
                          >
                            {item.value}
                          </Typography>
                        </CommonGrid2>
                        <CustomDiv>
                          <Gauge
                            width={65}
                            height={65}
                            value={item.score}
                            valueMax={item?.max_score}
                            cornerRadius="50%"
                            text={({ value, valueMax }) => `${item?.score}%`}
                            sx={(theme) => ({
                              [`& .${gaugeClasses.valueText}`]: {
                                fontSize: 11,
                                color: "#101828",
                                fontWeight: 600,
                              },
                              [`& .${gaugeClasses.valueArc}`]: {
                                fill: item.color,
                              },
                            })}
                          />
                        </CustomDiv>
                      </CommonGrid2>
                    )
                  )}
                </CommonGrid2>
                <table>
                  <tr>
                    {tableHead.map((item) => (
                      <TableHead width={item.width}>{item.title}</TableHead>
                    ))}
                  </tr>
                  {tableData.map((item, index) => (
                    <tr key={index}>
                      <TableData fontWeight="500">{item.title}</TableData>
                      <TableData fontWeight="500">{item.time}</TableData>
                      <TableData fontWeight="500">{item.date}</TableData>
                    </tr>
                  ))}
                </table>
              </Collapse>
              {/* </CustomDiv> */}
              <CommonButton
                value={chatBotData.details}
                background={"transparent"}
                boxShadow={"none"}
                color="#6941C6"
                padding={"10px 0px"}
                customStyle={{
                  "&:hover": {
                    boxShadow: "none",
                  },
                }}
                onClick={handleActivityChange}
              />
            </CustomDiv>
            <FullSizeChatBot
              chatBotData={chatBotData}
              setChatBotData={setChatBotData}
            />
          </CommonGrid2>
        </CommonGrid2>
        <CommonGrid2
          width={"300px"}
          border={"1px solid rgba(0, 0, 0, 0.12)"}
          top={"0px"}
          position={"sticky"}
          height={"100%"}
          overflowY={"auto"}
          scrollStyle
          background="#F6F8FB"
          scrollBar="5px"
          borderRadius={"10px"}
          ref={gridRef}
        >
          <CommonGrid2
            item
            padding={"1rem"}
            overflowY={"scroll"}
            scrollStyle
            displayBar="none"
          >
            <CommonTextField
              placeholder="Search Jobs, Candidates.."
              startIcon={<SearchIcon />}
              fullWidth
              padding={"12px 10px"}
              placeholderFontSize="14px"
            />
            <CommonGrid2
              marginTop={"1.5rem"}
              display={"flex"}
              gap={"1rem"}
              flexDirection={"column"}
            >
              <Typography variant="body4" fontWeight={600}>
                Recent Jobs
              </Typography>

              <QuickViewTab
                orientation="vertical"
                onChange={handleQuickViewTabChange}
              >
                {tabData.map((item, index) => {
                  return (
                    <Tab
                      label={
                        <CommonGrid2
                          display={"flex"}
                          alignItems={"center"}
                          gap="10px"
                        >
                          {item.name}
                        </CommonGrid2>
                      }
                      value={index}
                    />
                  );
                })}
              </QuickViewTab>
            </CommonGrid2>
          </CommonGrid2>
        </CommonGrid2>
      </TabContext>
    </CustomDiv>
  );
}
